import React, { FC } from "react";
import { faSparkles } from "@fortawesome/pro-solid-svg-icons/faSparkles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const SparklesSolid: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faSparkles} {...props} />
);
